import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { AutoCompletePropertiesType } from "@website/ui/auto-complete/auto-complete.types";
import { Button } from "@website/ui/button";
import { ChangeEvent, MouseEvent, useState } from "react";
export const useEnd = properties => {
  const $ = _c(53);
  const {
    parts,
    size
  } = properties;
  const [isOpenEndPopover, setIsOpenEndPopover] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsOpenEndPopover(false);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onCloseEndPopover = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsOpenEndPopover(true);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onClickEndTextField = t1;
  let t2;
  if ($[2] !== parts[1]) {
    t2 = event => {
      parts[1]?.onChangeQuery(event.target.value);
    };
    $[2] = parts[1];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onChangeEndPopoverTextField = t2;
  let t3;
  if ($[4] !== parts[1]) {
    t3 = item => {
      parts[1]?.onSelect(item.id);
      setIsOpenEndPopover(false);
    };
    $[4] = parts[1];
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onClickEndItem = t3;
  let t4;
  if ($[6] !== parts[1]) {
    t4 = item_0 => {
      parts[1]?.onSelectTag(item_0.id);
      setIsOpenEndPopover(false);
    };
    $[6] = parts[1];
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const onClickEndTag = t4;
  let t5;
  if ($[8] !== parts[1]) {
    t5 = event_0 => {
      event_0.stopPropagation();
      parts[1]?.onChangeQuery("");
    };
    $[8] = parts[1];
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const onEmptyEndSearchField = t5;
  let t6;
  if ($[10] !== parts[1]) {
    t6 = item_1 => {
      parts[1]?.onSelectHistory && parts[1]?.onSelectHistory(item_1.id);
      setIsOpenEndPopover(false);
    };
    $[10] = parts[1];
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const onClickHistoryItem = t6;
  const t7 = parts[1]?.text ? parts[1]?.label : "";
  const t8 = parts[1]?.text;
  let t9;
  if ($[12] !== parts[1]?.StartIcon) {
    t9 = parts[1]?.StartIcon ?? <MaterialIcon name="location_on" variant="fill" />;
    $[12] = parts[1]?.StartIcon;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = parts[1]?.placeholder || parts[1]?.label;
  let t11;
  if ($[14] !== size || $[15] !== t10 || $[16] !== t7 || $[17] !== t8 || $[18] !== t9) {
    t11 = {
      size,
      label: t7,
      value: t8,
      readOnly: true,
      onClick: onClickEndTextField,
      StartIcon: t9,
      placeholder: t10
    };
    $[14] = size;
    $[15] = t10;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== isOpenEndPopover) {
    t12 = {
      animate: "bottom" as const,
      open: isOpenEndPopover,
      onClose: onCloseEndPopover,
      position: "end" as const
    };
    $[20] = isOpenEndPopover;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Button EndIcon={<MaterialIcon name="arrow_forward" variant="outlined" />} color="neutral" equalDimension={true} onClick={onCloseEndPopover} variant="text" />;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const t14 = `جستجوی ${parts[1]?.label}`;
  let t15;
  if ($[23] !== t14) {
    t15 = {
      StartAction: t13,
      title: t14
    };
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  const t16 = `جستجوی ${parts[1]?.label}`;
  const t17 = parts[1]?.query;
  let t18;
  if ($[25] !== parts[1]?.StartIcon) {
    t18 = parts[1]?.StartIcon ?? <MaterialIcon name="location_on" variant="outlined" />;
    $[25] = parts[1]?.StartIcon;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== parts[1]?.query) {
    t19 = parts[1]?.query ? <MaterialIcon name="clear" variant="outlined" /> : <MaterialIcon name="search" variant="outlined" />;
    $[27] = parts[1]?.query;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  const t20 = parts[1]?.query ? onEmptyEndSearchField : undefined;
  let t21;
  if ($[29] !== onChangeEndPopoverTextField || $[30] !== t16 || $[31] !== t17 || $[32] !== t18 || $[33] !== t19 || $[34] !== t20) {
    t21 = {
      autoFocus: true,
      placeholder: t16,
      fullWidth: true,
      onChange: onChangeEndPopoverTextField,
      value: t17,
      StartIcon: t18,
      EndIcon: t19,
      onEndIconClick: t20
    };
    $[29] = onChangeEndPopoverTextField;
    $[30] = t16;
    $[31] = t17;
    $[32] = t18;
    $[33] = t19;
    $[34] = t20;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== onClickEndItem || $[37] !== parts[1]?.list) {
    t22 = parts[1]?.list.map(item_2 => ({
      ...item_2,
      role: "button",
      size: "large",
      onClick: () => onClickEndItem(item_2)
    })) || [];
    $[36] = onClickEndItem;
    $[37] = parts[1]?.list;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== onClickEndTag || $[40] !== parts[1]?.tags) {
    t23 = Array.isArray(parts[1]?.tags) && parts[1]?.tags?.map(item_3 => ({
      ...item_3,
      onClick: () => onClickEndTag(item_3)
    })) || [];
    $[39] = onClickEndTag;
    $[40] = parts[1]?.tags;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== onClickHistoryItem || $[43] !== parts[1]?.historyList) {
    t24 = parts[1]?.historyList?.map(item_4 => ({
      ...item_4,
      role: "button",
      size: "large",
      onClick: () => onClickHistoryItem(item_4)
    })) || [];
    $[42] = onClickHistoryItem;
    $[43] = parts[1]?.historyList;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== t11 || $[46] !== t12 || $[47] !== t15 || $[48] !== t21 || $[49] !== t22 || $[50] !== t23 || $[51] !== t24) {
    t25 = {
      endTextFieldProperties: t11,
      endPopoverProperties: t12,
      endTopAppBarProperties: t15,
      endPopoverSearchFieldProperties: t21,
      endItemsProperties: t22,
      endtags: t23,
      endHistoryItemsProperties: t24
    };
    $[45] = t11;
    $[46] = t12;
    $[47] = t15;
    $[48] = t21;
    $[49] = t22;
    $[50] = t23;
    $[51] = t24;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  return t25;
};